import React, { useState } from "react";
import DropdownSelect from "../../../dropdown/Dropdown";
import TextInput from "../../../UIComponent/TextInput";
import moment from "moment";
import Validation from "../../../../utils/validation/ValidationText";
import Selector from "../../../dropdown/commonDropdown/Selector";
import ButtonLoader from "../../../common/buttonLoader/ButtonLoader";

function OfficialRepInformation(props) {
  function subtractYears(numOfYears, date = new Date()) {
    date.setFullYear(date.getFullYear() - numOfYears);
    return date;
  }
  // const handleButtonClick = () => {
  //   props.setLoginToCorporateModalTrue();

  // };


  return (
    <div className="w-full">
      <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 px-3 lg:py-7 lg:pt-5 pt-4">
        {/* <button
          className="flex items-center col-start-7"
          onClick={handleButtonClick}
        >
          <span className="text-[#C00000] font-bold mx-1 2xl:text-[22px] lg:text-[18px] text-[13px] ">
            Edit CompanyName or UENnn
          </span>
          <img
            className="lg:w-7 md:w-5 w-4"
            src="/round-right-icon.png"
            alt=""
          />
        </button> */}

        <div className="grid grid-cols-12 gap-6 w-full ">
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  First Name
                  <span className="text-[#c00000]">*</span>
                </h2>

                <div className="flex items-center left-border-none">
                  <div className="w-[130px]">
                    <DropdownSelect
                      drpIdentity={"NamePrefixForOfficialRep"}
                      optionArray={props.mrMrs}
                      setFilterParameters={props.setFilterParameters}
                      value={props.repOfficialInformation.mrMrsId}
                      disabled={
                        props.repOfficialInformation
                          .organisationInformationId > 0
                      }
                    //disabled={props.organizationBasicInformation.organisationInformationId > 0 ? true : false}
                    />
                  </div>
                  <TextInput
                    placeholder=""
                    type="text"
                    name="firstName"
                    value={props.repOfficialInformation.firstName}
                    identity="OfficialRepInformation"
                    handleChange={props.handleChange}
                    onBlur={(e) =>
                      props.validate(
                        "firstName",
                        props.repOfficialInformation
                      )
                    }
                    disabled={
                      props.repOfficialInformation
                        .organisationInformationId > 0
                    }
                    isCurserAllowed={
                      props.repOfficialInformation
                        .organisationInformationId > 0
                    }
                  //disabled={props.organizationBasicInformation.organisationInformationId > 0 ? true : false}
                  //className={props.organizationBasicInformation.organisationInformationId > 0 ? `bg-[#f2f2f2]` : ""}
                  />
                </div>

                {/* <div className="dropdwn-input-email flex items-center">
                  <div className="w-[130px]">
                    <DropdownSelect
                      drpIdentity={"NamePrefix"}
                      optionArray={props.mrMrs}
                      setFilterParameters={props.setFilterParameters}
                      value={props.organizationBasicInformation.mrMrsId}
                    />

                  </div>
                  <TextInput
                    placeholder=""
                    type="text"
                    name="firstName"
                    value={props.organizationBasicInformation.firstName}
                    identity="BasicInformation"
                    handleChange={props.handleChange}
                    onBlur={(e) =>
                      props.validate(
                        "firstName",
                        props.organizationBasicInformation
                      )
                    }
                  />
                </div> */}
                <div>
                  <Validation error={props.validState.error.mrMrsId} />
                  <Validation error={props.validState.error.firstName} />
                </div>
              </div>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl theme-color font-bold 2xl:mb-1">
                  Last Name{" "}
                  <span className="text-[#c00000]">*</span>
                </h2>
                <TextInput
                  placeholder=""
                  type="text"
                  name="lastName"
                  value={props.repOfficialInformation.lastName}
                  identity="OfficialRepInformation"
                  handleChange={props.handleChange}
                  onBlur={(e) =>
                    props.validate(
                      "lastName",
                      props.repOfficialInformation
                    )
                  }
                  disabled={
                    props.repOfficialInformation
                      .organisationInformationId > 0
                  }
                  isCurserAllowed={
                    props.repOfficialInformation
                      .organisationInformationId > 0
                  }
                //disabled={props.organizationBasicInformation.organisationInformationId > 0 ? true : false}
                //className={props.organizationBasicInformation.organisationInformationId > 0 ? `bg-[#f2f2f2]` : ""}
                />
              </div>
            </div>
            <Validation error={props.validState.error.lastName} />
          </div>

          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Email Address <span className="text-[#c00000]">*</span>
                </h2>
                {/* <TextInput
                  placeholder=""
                  type="email"
                  name="email"
                  value={props.repOfficialInformation.email}
                  identity="OfficialRepInformation"
                  handleChange={props.handleChange}
                  onBlur={(e) =>
                    props.validate("email", props.repOfficialInformation)
                  }
                
                /> */}
                <DropdownSelect
                  drpIdentity={"Organisationemail"}
                  optionArray={props.Organisationemail}
                  setFilterParameters={props.setFilterParameters}
                  value={props.repOfficialInformation.emailID}
                />
              </div>
            </div>
            <Validation error={props.validState.error.emailID} />
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Contact Number{" "}
                  {/* <span className="text-[#c00000]">*</span> */}
                </h2>
                <TextInput
                  placeholder=""
                  type="number"
                  name="contactNo"
                  maxLength={20}
                  value={props.repOfficialInformation.contactNo}
                  identity="OfficialRepInformation"
                  handleChange={props.handleChange}

                  // onBlur={(e) =>
                  //   props.validate("contactNo", props.repOfficialInformation)
                  // }
                  disabled={
                    props.repOfficialInformation
                      .organisationInformationId > 0
                  }
                  isCurserAllowed={
                    props.repOfficialInformation
                      .organisationInformationId > 0
                  }
                />
              </div>
            </div>
            {/* <Validation error={props.validState.error.contactNo} /> */}
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12">
                <h2 className="text-xl text-[#757575] font-bold 2xl:mb-1">
                  Job Function <span className="text-[#c00000]">*</span>
                </h2>
                <Selector
                  drpIdentity="Designation_BasicInfo"
                  options={props.designationList}
                  isMulti
                  //   options={props.countriesWithPresence}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  // components={{ Option }}
                  onChange={props.handleChangeMultiDropdown}
                  allowSelectAll={true}
                  value={props.repOfficialInformation.selectedDesignation}
                  disabled={
                    props.repOfficialInformation
                      .organisationInformationId > 0
                  }
                />
              </div>
            </div>
            <Validation error={props.validState.error.selectedDesignation} />
          </div>
        </div>
      </div>
      {/* Save Button */}
      <div className="grid grid-cols-12 gap-6 pb-10">
        <div className="xl:col-span-12 lg:col-span-12 col-span-12 2xl:px-10 xl:px-10 lg:px-8 md:px-3 sm:px-4 px-4 mt-4">
          <a
            className="flex items-center justify-end"
          //href="/CreateCorporateMembers"
          >
            {props && props.isLoading === true ? (
              <ButtonLoader />
            ) : (
              <button
                className="w-32 px-7 py-3 btn-sm btn-red text-xl text-white font-semibold"
                onClick={() => props.onSave()}
              >
                Save
              </button>
            )}
          </a>
        </div>
      </div>
    </div>
  );
}

export default OfficialRepInformation;
